import React, { memo } from 'react';

// Components
import DashboardTabs from './DashboardTabs';

// Hooks
import { useDashboardData } from '../hooks';

/**
 * Dashboard Component
 * Main dashboard with tabbed interface for Secondary Sales, Sales Operations, Team, and WSS data
 * Refactored from TabComponent.js with Tailwind CSS
 * Memoized to prevent unnecessary re-renders
 */
const Dashboard = memo(() => {
  const { setActiveTab, tabs } = useDashboardData();

  return (
    <div 
      className='rounded-xl !mx-4 my-2 mb-6 !w-[94%] md:w-full'
    >
      <DashboardTabs
        tabs={tabs}
        defaultActiveKey='secondary-sales'
        onTabChange={setActiveTab}
      />
    </div>
  );
});

export default Dashboard;
